import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type PoliciesDetachConfirmationModalProps = {
  policyName: string;
  onConfirm: () => void;
};

const PoliciesDetachConfirmationModal = create(function PoliciesDetachConfirmationModal({
  onConfirm,
  policyName,
}: PoliciesDetachConfirmationModalProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    modal.resolve();
    modal.hide();
    onConfirm();
  };

  return (
    <ConfirmationModal
      title="Detach policy"
      confirmationButtonLabel="Detach"
      confirmationButtonVariant="dangerPrimary"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        Are you sure you want to detach <strong>{policyName}</strong> policy?
      </ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showPoliciesDetachConfirmationModal = (props: PoliciesDetachConfirmationModalProps) =>
  show(PoliciesDetachConfirmationModal, props);
